import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";

const URL = "https://www.homeapproach.com/contact";
const TITLE = "Contact Home Approach | Employers, Partners & Press";
const DESC = "Talk to Home Approach about offering a homeownership benefit, community partnerships, professional partnerships or press. The right person will reply.";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [{
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://www.homeapproach.com/" },
          { "@type": "ListItem", position: 2, name: "Contact", item: URL },
        ],
      }),
    }],
  }),
  component: Contact,
});
